import { mapMutations } from 'vuex';

import {
  UPDATE_DRAFT_ORDER,
} from '@/store/orders/constants';
import { ORDER_STEP_MAPPING, ORDER_STEP } from '@/utils/constants';

export default {
  name: 'ProgressBar',
  props: {
    disablePre: {
      type: Boolean,
      default: false,
    },
    isDraft: {
      type: Boolean,
      default: true,
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    stepDescription() {
      return this.steps[this.value]?.description;
    },
  },
  methods: {
    ...mapMutations('orders', {
      updateDraftOrder: UPDATE_DRAFT_ORDER,
    }),
    onClick(index) {
      if (index > this.value || (this.disablePre && index < this.value)) {
        return;
      }
      this.setStep(index);
    },
    nextStep() {
      this.setStep(this.value + 1);
    },
    setStep(step) {
      const orderConfigStepIndex = ORDER_STEP.indexOf(ORDER_STEP_MAPPING.ORDER_CONFIG);
      if (step < orderConfigStepIndex && this.isDraft) {
        this.updateDraftOrder({
          menuId: null,
          storeId: null,
        });
      }
      this.$emit('input', step);
    },
  },
};
